/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { EntityFinderDialog, EntityFinderParams, ISortModel } from '@core';

import { AccountAdminGroup } from '@models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';
import { ColDef } from '@ag-grid-community/core';
import { AccountDbQueryService } from '../services/account-db-query.service';

export interface AccountAdminGroupFinderParams extends EntityFinderParams {
  title?: string;
  accountAdminGroups: AccountAdminGroup[];
}

@Component({
  selector: 'prox-account-admin-group-finder',
  template: EntityFinderDialog.HTML,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class AccountAdminGroupFinderDialog extends EntityFinderDialog<AccountAdminGroup, AccountAdminGroupFinderParams> {
  params: AccountAdminGroupFinderParams;

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<AccountAdminGroupFinderParams>,
    public dbQueryService: AccountDbQueryService,
  ) {
    super(ref, config);
    UtilFns.assert(config.data);
    this.params = config.data;
    UtilFns.assertNonNull(this.params.accountAdminGroups, 'accountAdminGroups');
  }

  override async initialize() {
    return {
      header: this.params.title ?? `Select Account Admin Groups`,
      width: 'calc(40vw)',
      rowModelType: 'clientSide',
    } as const;
  }

  override async initDatasource() {
    return this.params.accountAdminGroups;
  }

  override getColDefsAndSortModel() {
    const colDefs = [{ headerName: 'Name', field: 'name', filter: 'agTextColumnFilter' }] as ColDef[];
    const sortModel = [{ colId: 'name', sort: 'asc' }] as ISortModel;
    return [colDefs, sortModel] as const;
  }
}
